import * as tslib_1 from "tslib";
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { unsubscribe } from '@utils/object.utils';
var UiMatDatepickerIntl = /** @class */ (function (_super) {
    tslib_1.__extends(UiMatDatepickerIntl, _super);
    function UiMatDatepickerIntl(_translateService, appState) {
        var _this = _super.call(this) || this;
        _this._translateService = _translateService;
        _this._setLabels();
        _this._langChangeSub = appState.language.change$
            .subscribe(function () { return _this._setLabels(); });
        return _this;
    }
    UiMatDatepickerIntl.prototype.ngOnDestroy = function () {
        unsubscribe(this._langChangeSub);
    };
    UiMatDatepickerIntl.prototype._setLabels = function () {
        this.calendarLabel = this._translateService.instant('calendar_label');
        this.openCalendarLabel = this._translateService.instant('open_calendar_label');
        this.prevMonthLabel = this._translateService.instant('previous_month_label');
        this.nextMonthLabel = this._translateService.instant('next_month_label');
        this.prevYearLabel = this._translateService.instant('previous_year_label');
        this.nextYearLabel = this._translateService.instant('next_year_label');
        this.prevMultiYearLabel = this._translateService.instant('previous_20_years_label');
        this.nextMultiYearLabel = this._translateService.instant('next_20_years_label');
        this.switchToMonthViewLabel = this._translateService.instant('choose_date_label');
        this.switchToMultiYearViewLabel = this._translateService.instant('choose_month_and_year_label');
        this.changes.next();
    };
    return UiMatDatepickerIntl;
}(MatDatepickerIntl));
export { UiMatDatepickerIntl };
